import { AbstractControl } from '@angular/forms'

/**
 * modifies the given control status to enabled/disabled according to the provided value.
 * if the controls has an ancestor that is disabled, the control will not be enabled.
 */
export function modifyControlStatus(ctrl: AbstractControl, enable: boolean) {
  const emitOpts: Parameters<AbstractControl['enable']> = [{ emitEvent: true, onlySelf: true }]

  if (enable && ctrl.disabled && !hasDisabledAncestor(ctrl)) {
    ctrl.enable(...emitOpts)
  } else if (!enable && ctrl.enabled) {
    ctrl.disable(...emitOpts)
  }
}

function hasDisabledAncestor(ctrl: AbstractControl): boolean {
  if (!ctrl.parent) {
    return false
  }
  return ctrl.parent.disabled || hasDisabledAncestor(ctrl.parent)
}
